import { useAuth } from '../auth';
import { usePageTitle } from '../hooks/usePageTitle';

interface AuthErrorViewProps {
  message: string;
}

/**
 * Terminal auth failure — Auth0 is unreachable, or a purge-and-retry already failed. Rendered instead
 * of the app shell so the user gets an explanation and a way out rather than a blank page.
 */
export default function AuthErrorView({ message }: AuthErrorViewProps) {
  const { login } = useAuth();
  usePageTitle('Sign-in error');
  return (
    <div className="not-configured" data-testid="auth-error-view">
      <h1 style={{ marginTop: 0 }}>bevi-ailab: can&apos;t sign you in</h1>
      <p>{message}</p>
      <p className="muted">Signing in again usually clears this. If it keeps happening, tell an admin.</p>
      <button type="button" data-testid="auth-error-signin-button" onClick={() => login()}>
        Sign in again
      </button>
    </div>
  );
}
